import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    blacky: {
      main: '#222222',
      contrastText: '#fff'
    }
  }
});
